import UserSettingsPage from './userSettingsPages.view';

export default UserSettingsPage;
